import React, { Component } from 'react';
import { Form, Input, Radio, Button, message, Spin, Select, Modal, Card } from 'antd';
import { Redirect } from 'react-router';
import ReactQuill, { Quill } from 'react-quill';
import { ImageDrop } from 'quill-image-drop-module';
import 'react-quill/dist/quill.snow.css';
import './addGoods.css';
import utils from '../../../utils/common';
import TreeMenu from '../../../components/backEnd/treeMenu';//商品类型模版
import UploadBox from '../../../components/backEnd/uploadBox';//富文本编辑器上传图片模板

const RadioGroup = Radio.Group;
const Option = Select.Option;
const merchantVersionOptions = [
  {value: 'LTFJCB', label: '支付基础版'},
  {value: 'LTFYOUXB', label: '优选版'},
  {value: 'LTFGJB', label: '营销高级版'},
  {value: 'LTFYKTB', label: '一卡通版'},
  {value: 'CANYINJCB', label: '餐饮基础版'},
  {value: 'CANYINYINGXB', label: '餐饮高级版'},
  {value: 'CANYINYKTB', label: '餐饮一卡通版'},
  {value: 'LTSYJCB', label: '零售基础版'},
  {value: 'LTSYYOUXB', label: '零售优选版'},
  {value: 'LTSYYINGXB', label: '零售营销版'},
  {value: 'LTSYLIANSB', label: '零售连锁版'},
  {value: 'LTSYYKTB', label: '零售一卡通版'},
  {value: 'LTSYCYGYLB', label: '餐饮平台版'},
  {value: 'SHANGMB', label: '商盟平台版'},
  {value: 'JIAYOUZHANB', label: '加油站高级版'},
  {value: 'SHANGQB', label: '商圈平台版'},
  {value: 'JIAYOUZHANYFYTB', label: '加油站平台版'},
  {value: 'LINGSHOUPTB', label: '零售平台版'}
];
Quill.register('modules/imageDrop', ImageDrop);
class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true,
      isShow: true, // 显示商品图片 false显示
      uploadBoxVisible: false,
      //is_rebeatstate: false, //选择业绩返佣，显示返佣条件
      redirect: false,
      maxLength: 10,
      isLoading: false,
      treeData: [], // 商品类别
      brandsList: [], // 品牌列表
      thirdChannelList: [], // 第三方场上列表
      uploadUrl: '',
      form: {
        goods_name: '', // 商品名称
        goods_category_id: '', // 商品类别ID
        goods_bar_no: '', // 商品条形码
        is_post: 0, // 是否需要发货
        sale_price: '', // 商品售价
        cost_price: '', // 商品成本
        goods_pic: '', // 默认商品图片
        goods_details: '', // 商品描述
        goods_brand_name: null, // 商品品牌名称
        goods_brand_id: '', // 商品品牌id
        goods_property: '', // 商品属性 1 硬件 2 软件
        self_support: null, // 是否自营 1 是 2 否
        valid_days: null, //sn码有效期
        pay_type: 1, // 支付方式
        return_com_type: '', // 返佣类型 1 激活返佣 2 业绩返佣
        return_com_con: '', // 返佣条件
        return_com_price: '', // 返佣金额
        return_device_num: '', // 返佣设备数
        goods_activate_price: '', // 激活金额
        use_third_channel: '', // 是否调用第三方接口 1 是 2 否
        third_channel_id: '', // 第三方通道主键id
        channel_flag: '', // 接口厂商标识 1 MYBANK
        product_id: '', //产品版本id
        product: '', // 商户版本
        is_distinguish_merchant_store: '', // 是否区分商户/门店版本，页面控制字段
        merchant_type: '', // 商户版本归属 1 商户 2 门店
        // edit
        sell_out: '', // 销售量
        status: '', // 商品状态
      }
    };
  }
  componentWillMount() {
    if (window.common.loginOut(this)) {
      // 获取商品类型，商品品牌，第三方厂商
      Promise.all([window.api('goods.getcategorylist', {}), window.api('eps.getgoodsbrand', {brand_status: 1, page_size: 100}), window.api('goods.getthirdchannellist')]).then(res => {
        res[2].goods_third_channel_list.forEach(item => {
          item.id = Number(item.id);
        });
        res[1].goods_brand_list.forEach(item => {
          item.id = Number(item.id);
        });
        this.setState({treeData: res[0].goods_category_list, brandsList: res[1].goods_brand_list, thirdChannelList: res[2].goods_third_channel_list});
        this.initForm();
      }).catch(err => {
        if (err.service_error_code === 'EPS000000801') {
          this.setState({redirect: true});
        }
        message.error(err.service_error_message);
      });
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  //生成条形码
  getbarno = () => {
    window.api('goods.getbarno', {}).then((rs) => {
      const form = Object.assign(this.state.form, {goods_bar_no: rs.barNo});
      this.setState({form});
      this.props.form.setFieldsValue({goods_bar_no: rs.barNo});
    }).catch(error => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
      }
      message.error(error.service_error_message);
    });
  }

  // 上传图片
  uploadImgEvent = (e) => {
    e.preventDefault();
    const info = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(info);
    const flag = window.common.beforeUpload(info, message); //上传之前判断图片大小
    const _this = this;
    if (flag === true) {
      reader.onload = function () {
        const params = {pic_name: info.name, goods_pic: this.result};
        window.api('eps.upload', params).then(rs => {
          if (_this.state.uploadBoxVisible === true) {
            _this.setState({uploadUrl: rs.pic_path});
          } else {
            const form = Object.assign(_this.state.form, {goods_pic: rs.pic_path});
            _this.setState({form, isShow: false});
          }
        }).catch(error => {
          if (error.service_error_code === 'EPS000000801') {
            this.setState({redirect: true});
          }
          message.error(error.service_error_message);
        });
      };
    }
  }

  // 编辑时初始化表格
  initForm = () => {
    if (!this.props.location.state.id) return false;
    window.api('goods.getgoodsdetail', {id: this.props.location.state.id}).then((res) => {
      let params = {...res};
      params.goods_pic = res.goods_picture;
      params.goods_picture = null;
      if (Number(params.goods_property) === 1) {
        const merchantType = Number(params.merchant_type);
        params.merchant_type = merchantType === 1 || merchantType === 2 ? merchantType : '';
        params.is_distinguish_merchant_store = params.merchant_type ? 1 : 0;
      } else {
        params.product = '';
        params.merchant_type = '';
        params.is_distinguish_merchant_store = '';
      }
      params = utils.dealElement(params);
      const form = Object.assign({}, this.state.form, params);
      this.setState({form, isShow: false}, () => {
        if (Number(form.goods_property) === 1) {
          const fieldValues = {
            product: form.product || '',
            is_distinguish_merchant_store: form.is_distinguish_merchant_store
          };
          if (form.is_distinguish_merchant_store === 1) {
            fieldValues.merchant_type = form.merchant_type;
          }
          this.props.form.setFieldsValue(fieldValues);
        }
      });
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 添加商品
  addtionProEvent = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const form = Object.assign({}, this.state.form, values);
        if (Number(form.goods_property) !== 1) {
          form.product = '';
          form.merchant_type = '';
        } else if (Number(form.is_distinguish_merchant_store) !== 1) {
          form.merchant_type = '';
        }
        if (form.goods_property) {
          if (Number(form.goods_property) === 2) {
            if (!form.return_com_type) {
              message.error('请选择返佣方式');
              return;
            } else if (!form.use_third_channel) {
              message.error('请选择是否需要调用第三方接口');
              return;
            }
          } else if (Number(form.goods_property) === 1) {
            // eslint-disable-next-line no-lonely-if
            if (!form.self_support) {
              message.error('请选择该商品是否为自营');
              return;
            }
          }
        }
        if (this.state.form.goods_pic === '') {
          message.error('请上传图片');
          return false;
        }
        if (this.state.form.goods_details === '') {
          message.error('请填写商品详情');
          return false;
        }
        const otherParams = {
          goods_brand_name: null,
          channel_flag: null
        };
        if (form.goods_brand_id) {
          this.state.brandsList.forEach(item => {
            item.id === form.goods_brand_id ? otherParams.goods_brand_name = item.brand_name : null;
          });
        }
        if (form.third_channel_id) {
          this.state.thirdChannelList.forEach(item => {
            item.id === form.third_channel_id ? otherParams.channel_flag = item.channel_flag : null;
          });
        }
        let params = Object.assign(form, otherParams);
        delete params.discount_price;
        delete params.goods_category_name;
        delete params.goods_num;
        delete params.sell_out;
        delete params.is_distinguish_merchant_store;
        delete params.service_error_code;
        delete params.service_error_message;
        delete params.service_status;
        params = utils.dealElement(params);
        const url = form.id ? 'goods.modgoods' : 'goods.addgoods';
        window.api(url, params).then((res) => {
          message.success(res.service_error_message);
          this.props.history.push({pathname: '/main/list'});
        }).catch((error) => {
          error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
          message.error(error.service_error_message);
        });
      }
    });
  }

  // 关闭添加/编辑商品
  resetEvent = () => {
    this.props.history.goBack();
  }

  // 改变表单选项
  changeForm = (type, value) => {
    if (value === undefined) return;
    value = utils.deleteBlank(value);
    let form = this.state.form;
    switch (type) {
      case 'goods_category_id':
        this.props.form.setFieldsValue({goods_category_id: value});
        break;
      case 'return_com_type':
        if (Number(value.target.value) === 1) {
          form = Object.assign(form, {return_com_con: ''});
        }
        value = value.target.value;
        break;
      case 'use_third_channel':
        if (Number(value.target.value) === 2) {
          form = Object.assign(form, {channel_flag: '', third_channel_id: ''});
        }
        value = value.target.value;
        break;
      case 'is_distinguish_merchant_store':
        value = value.target.value;
        if (Number(value) !== 1) {
          form = Object.assign(form, {merchant_type: ''});
          this.props.form.setFieldsValue({merchant_type: undefined});
        }
        break;
      case 'product':
      case 'merchant_type':
        value = value && value.target ? value.target.value : value;
        break;
      case 'goods_property':
        if (Number(value.target.value) !== 1 && Number(form.goods_property) === 1) {
          const merchantVersionFields = {
            product: undefined,
            is_distinguish_merchant_store: undefined
          };
          if (Number(form.is_distinguish_merchant_store) === 1) {
            merchantVersionFields.merchant_type = undefined;
          }
          this.props.form.setFieldsValue(merchantVersionFields);
          form = Object.assign(form, {
            product: '',
            is_distinguish_merchant_store: '',
            merchant_type: ''
          });
        }
        if (Number(value.target.value) === 2) { // 硬件
          form = Object.assign(form, {self_support: ''});
        } else {
          const change = {
            return_com_type: '',
            return_com_con: '',
            return_com_price: '',
            return_device_num: '',
            goods_activate_price: '',
            use_third_channel: '',
            channel_flag: '',
            third_channel_id: '',
          };
          form = Object.assign(form, change);
        }
        value = value.target.value;
        break;
      default:
        value = value.target.value;
    }
    form = Object.assign(form, {[type]: value});
    this.setState({form});
  }
  changeDetailEvent = (value) => {
    const form = Object.assign(this.state.form, {goods_details: value});
    this.setState({form});
  }
  //富文本编辑器配置
  modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{header: 1}, {header: 2}],
        [{list: 'ordered'}, {list: 'bullet'}],
        [{script: 'sub'}, {script: 'super'}],
        [{indent: '-1'}, {indent: '+1'}],
        [{direction: 'rtl'}],
        [{header: [1, 2, 3, 4, 5, 6, false]}],
        [{color: []}, {background: []}],
        [{font: []}],
        [{align: []}],
        ['link', 'image', 'video'],
        ['clean']
      ],
      handlers: {
        image: this.showUploadBox.bind(this)
      }
    },
    imageDrop: true
  }
  showUploadBox() {
    this.setState({uploadBoxVisible: true, uploadUrl: ''});
  }
  hideUploadBox = () => {
    this.setState({
      uploadBoxVisible: false
    });
  }
  handleUpload = () => {
    if (typeof this.reactQuillRef.getEditor !== 'function') return;
    if (this.state.uploadUrl === '') {
      message.error('请先上传图片');
      return false;
    }
    const quill = this.reactQuillRef.getEditor();
    const range = quill.getSelection();
    const index = range ? range.index : 0;
    quill.insertEmbed(index, 'image', this.state.uploadUrl, Quill.sources.USER);//插入图片
    quill.setSelection(index + 1);//光标位置加1
    this.hideUploadBox();
  }
  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      brandsList, redirect, isLoading, form, disabled, treeData, maxLength, isShow, thirdChannelList, showThirdChannel
    } = this.state;
    if (redirect) return <Redirect to="/login" />;
    return (
      <div className="add-goods-page">
        <Spin spinning={isLoading}>
          <Form
            onSubmit={this.addtionProEvent}
            className="add-goods-form"
            layout="vertical"
            name="form"
            id="form"
          >
            <Card title="基本信息" className="add-goods-card">
              <Form.Item label="商品名称">
              {getFieldDecorator(
                'goods_name',
                {
                  initialValue: form.goods_name || '',
                  rules: [{required: true, message: '请输入商品名称！'}]
                }
              )(<Input placeholder="请输入商品名称" className="add-goods-input" />)}
              </Form.Item>
              <Form.Item label="商品条形码">
                {getFieldDecorator('goods_bar_no', {
                  initialValue: form.goods_bar_no || '',
                  rules: [{ required: true, message: '请生成商品条形码！' }]
                })(
                  <div className="add-goods-barcode">
                    <Input placeholder="请生成商品条形码" disabled={disabled} className="add-goods-input" value={form.goods_bar_no || ''} readOnly />
                    <Button type="primary" onClick={this.getbarno.bind(this)}>生成条形码</Button>
                  </div>
                )}
              </Form.Item>
              <Form.Item label="商品类型">
                {getFieldDecorator('goods_category_id', {
                  initialValue: form.goods_category_id || '',
                  rules: [{ required: true, message: '请选择商品类型' }]
                })(<TreeMenu selParentEvent={(value) => this.changeForm('goods_category_id', value)} parent_id={form.goods_category_id} treeData={treeData} />)}
              </Form.Item>
              <Form.Item label="商品品牌">
                {getFieldDecorator('goods_brand_id', {
                  initialValue: form.goods_brand_id || '',
                  rules: [{ required: true, message: '请选择商品品牌' }]
                })(
                  <Select placeholder="请选择商品品牌" className="add-goods-select">
                    {brandsList.map((item, index) => (
                      <Option value={item.id} key={item.id}>{item.brand_name}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Card>

            <Card title="价格与支付" className="add-goods-card">
              <Form.Item label="商品成本价">
                {getFieldDecorator('cost_price', {
                  initialValue: `${form.cost_price}` || '',
                  rules: [
                    { required: true, message: '请输入商品成本价！' },
                    { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)' }
                  ]
                })(<Input placeholder="请输入商品成本价" maxLength={maxLength} className="add-goods-input add-goods-input-number" />)}
                <span className="add-goods-unit">元</span>
              </Form.Item>
              <Form.Item label="商品售价">
                {getFieldDecorator('sale_price', {
                  initialValue: `${form.sale_price}` || '',
                  rules: [
                    { required: true, message: '请输入商品售价！' },
                    { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)' }
                  ]
                })(<Input placeholder="请输入商品售价" maxLength={maxLength} className="add-goods-input add-goods-input-number" />)}
                <span className="add-goods-unit">元</span>
              </Form.Item>
              <Form.Item label="付款方式">
                {getFieldDecorator('pay_type', {
                  initialValue: form.pay_type || '',
                  rules: [{ required: true, message: '请选择付款方式！' }]
                })(
                  <RadioGroup onChange={(e) => this.changeForm('pay_type', e)} className="add-goods-radio-group">
                    <Radio value={1}>扣款</Radio>
                    <Radio value={2}>冻结</Radio>
                  </RadioGroup>
                )}
              </Form.Item>
            </Card>

            <Card title="商品属性" className="add-goods-card">
              <Form.Item label="选择商品属性">
              {getFieldDecorator(
                'goods_property',
                {
                  initialValue: form.goods_property || '',
                  rules: [
                    {required: true, message: '请选择商品属性！'}
                  ]
                }
              )(
                <RadioGroup onChange={(e) => this.changeForm('goods_property', e)} className="add-goods-radio-group">
                  <Radio value={1}>软件</Radio>
                  <Radio value={2}>硬件</Radio>
                  <Radio value={3}>流量商品</Radio>
                </RadioGroup>
              )}
            </Form.Item>
              {
                Number(form.goods_property) === 1 ? <div>
                  <Form.Item label="商户版本">
                    {getFieldDecorator('product', {
                      initialValue: form.product || '',
                      rules: [{required: true, message: '请选择商户版本'}]
                    })(<Select
                      placeholder="请选择商户版本"
                      className="add-goods-select"
                      showSearch
                      optionFilterProp="children"
                      onChange={(value) => this.changeForm('product', value)}
                    >
                      {merchantVersionOptions.map(item => (
                        <Option value={item.value} key={item.value}>{item.value}：{item.label}</Option>
                      ))}
                    </Select>)}
                  </Form.Item>
                  <Form.Item label="是否区分商户/门店版本">
                    {getFieldDecorator('is_distinguish_merchant_store', {
                      initialValue: form.is_distinguish_merchant_store,
                      rules: [{required: true, message: '请选择是否区分商户/门店版本'}]
                    })(<RadioGroup
                      onChange={(e) => this.changeForm('is_distinguish_merchant_store', e)}
                      className="add-goods-radio-group"
                    >
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </RadioGroup>)}
                  </Form.Item>
                  {
                    Number(form.is_distinguish_merchant_store) === 1 ? <Form.Item label="商户版本归属">
                      {getFieldDecorator('merchant_type', {
                        initialValue: form.merchant_type || '',
                        rules: [{required: true, message: '请选择商户版本归属'}]
                      })(<RadioGroup
                        onChange={(e) => this.changeForm('merchant_type', e)}
                        className="add-goods-radio-group"
                      >
                        <Radio value={1}>商户</Radio>
                        <Radio value={2}>门店</Radio>
                      </RadioGroup>)}
                    </Form.Item> : null
                  }
                </div> : null
              }
            {
              Number(form.goods_property) === 3 ? <Form.Item
                label="交易流水金额"
              >
                {getFieldDecorator(
                  'flow_limit_amt',
                  {
                    initialValue: form.flow_limit_amt || '',
                    rules: [
                      {required: true, message: '请输入交易流水金额！'},
                      // {pattern: (/^\d+$/), message: '只能输入整数'}
                    ]
                  },
                )(<Input placeholder="请输入交易流水金额" maxLength={20} />)
                }
              </Form.Item> : null
            }
            {
              Number(form.goods_property) === 2 ?
                (<div>
                  <Form.Item
                    label="选择返佣方式"
                  >
                    {
                      getFieldDecorator(
                        'return_com_type',
                        {
                          initialValue: form.return_com_type || '',
                          rules: [
                            {required: true, message: '请选择返佣方式！'}
                          ]
                        }
                      )(<RadioGroup onChange={this.changeForm.bind(this, 'return_com_type')}>
                        <Radio value={1}>激活返佣</Radio>
                        <Radio value={2}>业绩返佣</Radio>
                      </RadioGroup>)
                    }
                  </Form.Item>
                  <Form.Item
                    label="商品激活价格"
                  >
                    {getFieldDecorator(
                      'goods_activate_price',
                      {
                        initialValue: `${form.goods_activate_price}` || '',
                        rules: [
                          {required: true, message: '请输入商品激活价格！'},
                          {pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)'}
                        ]
                      }
                    )(<Input placeholder="请输入商品激活价格" maxLength={maxLength} />)
                    }元
                  </Form.Item>
                  <Form.Item
                    label="商品返佣价格"
                  >
                    {getFieldDecorator(
                      'return_com_price',
                      {
                        initialValue: `${form.return_com_price}` || '',
                        rules: [
                          {required: true, message: '请输入商品返佣价格！'},
                          {pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)'}
                        ]
                      }
                    )(<Input placeholder="请输入商品返佣价格" maxLength={maxLength} />)
                    }元
                  </Form.Item>
                  <Form.Item
                    label="返佣设备个数"
                  >
                    {getFieldDecorator(
                      'return_device_num',
                      {
                        initialValue: `${form.return_device_num}` || '',
                        rules: [
                          {required: true, message: '请输入商品返佣设备个数！'},
                          {pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)'}
                        ]
                      }
                    )(<Input placeholder="请输入商品返佣设备个数" maxLength={maxLength} />)
                    }个
                  </Form.Item>
                  {
                    form.return_com_type === 2 ? <Form.Item
                      label="返佣条件"
                    >
                      交易额满
                      {getFieldDecorator(
                        'return_com_con',
                        {
                          initialValue: `${form.return_com_con}` || '',
                          rules: [
                            {required: true, message: '请输入交易额！'},
                            {pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: '只能输入整数或小数(保留后两位)'}
                          ]
                        }
                      )(<Input style={{width: '200px'}} placeholder="精确到小数点后两位" />)
                      }万元
                    </Form.Item> : null
                  }
                  <Form.Item
                    label="调用第三方接口"
                  >
                    {getFieldDecorator(
                      'use_third_channel',
                      {
                        initialValue: form.use_third_channel || '',
                        rules: [
                          {required: true, message: '请选择是否调用第三方接口！'},
                        ]
                      }
                    )(<RadioGroup onChange={this.changeForm.bind(this, 'use_third_channel')}>
                      <Radio value={1}>是</Radio>
                      <Radio value={2}>否</Radio>
                    </RadioGroup>)
                    }
                  </Form.Item>
                  {
                    Number(form.use_third_channel) === 1 ? <Form.Item
                      label="接口厂商"
                    >
                      {getFieldDecorator(
                        'third_channel_id',
                        {
                          initialValue: form.third_channel_id || '',
                          rules: [
                            {required: true, message: '请选择接口厂商'}
                          ]
                        }
                      )(<Select style={{width: '60%'}}>
                        {
                          thirdChannelList.map((item, index) => (
                            <Option value={item.id} key={index}>{item.channel_name}</Option>
                          ))
                        }
                      </Select>)
                      }
                    </Form.Item> : null
                  }
                </div>)
                : null
            }
            {
              Number(form.goods_property) === 1 ? <Form.Item
                label="是否为自营"
              >
                {getFieldDecorator(
                  'self_support',
                  {
                    initialValue: form.self_support || '',
                    rules: [
                      {required: true, message: '请选择是否为自营'}
                    ]
                  },
                )(<RadioGroup onChange={this.changeForm.bind(this, 'self_support')}>
                  <Radio value={1}>自营</Radio>
                  <Radio value={2}>非自营</Radio>
                </RadioGroup>)
                }
              </Form.Item> : null
            }
            {
              Number(form.goods_property) === 1 ? <Form.Item
                label="商品sn码有效期"
              >
                {getFieldDecorator(
                  'valid_days',
                  {
                    initialValue: form.valid_days || '',
                    rules: [
                      {required: true, message: '请输入有效期'},
                      {pattern: /^\+?[1-9]\d{0,9}?$/, message: '请输入1-9数字'}
                    ]
                  }
                )(<Input placeholder="大于0的整数" type="text" className='add-goods-input-number'/>)
                }<span className="add-goods-unit">天</span>
              </Form.Item> : null
            }
            {
              Number(form.self_support) === 1 && Number(form.goods_property) === 2 ? <Form.Item
                label="产品版本ID"
              >
                {getFieldDecorator(
                  'product_id',
                  {
                    initialValue: form.product_id || '',
                    rules: [
                      {required: true, message: '请输入产品版本id'},
                      {pattern: /^\+?[1-9]\d{0,9}?$/, message: '请输入1-9数字'}
                    ]
                  }
                )(<Input placeholder="请输入产品版本id" type="text" />)
                }
              </Form.Item> : null
            }
            <Form.Item label="是否需要发货">
              {getFieldDecorator('is_post', {
                initialValue: form.is_post,
                rules: [{ required: true, message: '请选择是否发货' }]
              })(
                <RadioGroup onChange={(e) => this.changeForm('is_post', e)} className="add-goods-radio-group">
                  <Radio value={0}>是</Radio>
                  <Radio value={1}>否</Radio>
                </RadioGroup>
              )}
            </Form.Item>
            </Card>

            <Card title="商品图片" className="add-goods-card">
              <Form.Item label={<span><em className="add-goods-required">*</em>商品主图</span>}>
              <div className="add-goods-upload">
                <div className="add-goods-upload__inner">
                  <input type="file" accept="image/jpg,image/jpeg,image/png,image/bmp" onChange={this.uploadImgEvent} ref="file" name="file" className="add-goods-upload__input" />
                  <img src={form.goods_pic} alt="" className={`add-goods-upload__preview ${isShow ? 'add-goods-upload__preview--hide' : ''}`} />
                  <div className={`add-goods-upload__placeholder ${!isShow ? 'add-goods-upload__placeholder--hide' : ''}`}>
                    <span className="add-goods-upload__icon">+</span>
                    <span className="add-goods-upload__text">点击上传商品主图</span>
                    <span className="add-goods-upload__hint">支持 JPG、PNG、BMP，建议尺寸 800×800</span>
                  </div>
                </div>
              </div>
            </Form.Item>
            </Card>

            <Card title="商品详情" className="add-goods-card">
              <Form.Item label={<span><em className="add-goods-required">*</em>商品描述</span>}>
              <div className="add-goods-quill">
                <ReactQuill
                  placeholder="请输入商品描述详情"
                  theme="snow"
                  className="add-goods-quill-editor"
                  value={this.state.form.goods_details}
                  onChange={this.changeDetailEvent}
                  modules={this.modules}
                  ref={(el) => { this.reactQuillRef = el; }}
                />
                <Modal
                  title="上传图片"
                  visible={this.state.uploadBoxVisible}
                  onCancel={this.hideUploadBox}
                  onOk={this.handleUpload}
                  maskClosable={false}
                  width={500}
                >
                  <UploadBox changeImageBeforeUpload={this.uploadImgEvent} src={this.state.uploadUrl} />
                </Modal>
              </div>
            </Form.Item>
            </Card>

            <Form.Item className="add-goods-actions">
              <Button type="primary" htmlType="submit" size="large">保存</Button>
              <Button size="large" onClick={this.resetEvent}>取消</Button>
            </Form.Item>
          </Form>
        </Spin>
      </div>
    );
  }
}
export default Form.create()(Add);



// WEBPACK FOOTER //
// ./src/containers/backEnd/productManagement/addGoods.jsx